/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { format } from '@msdyn365-commerce-modules/utilities';
import { getUrlSync, IComponent, IComponentProps } from '@msdyn365-commerce/core';
import { ICartState } from '@msdyn365-commerce/global-state';
import { observer } from 'mobx-react';
import * as React from 'react';

export interface ICartIconData {
    cart: ICartState;
}

export interface ICartIconComponentProps extends IComponentProps<ICartIconData> {
    className?: string;
    cartLabel: string;
}

export interface ICartIconComponent extends IComponent<ICartIconComponentProps> {
}

/**
 *
 * CartIcon component
 * @extends {React.FC<ICartIconComponentProps>}
 */
const CartIcon: React.FC<ICartIconComponentProps> = observer((props: ICartIconComponentProps) => {
    const { cartLabel, data: {cart} } = props;
    const cartLink = getUrlSync('cart', props.context.actionContext);
    const cartItem = cart ? `(${cart.totalItemsInCart})` : '';
    const label = format(cartLabel, cartItem) || `Shopping bag, ${cartItem} items`;
    return (
        <a title={label} className='msc-cart-icon msc-btn' href={cartLink} aria-label={label} >
            <div className='msc-cart-icon__count' aria-hidden={true}>
               My Cart {cartItem}
            </div>
        </a>
    );
});

// Following code is been replaced with 'CartIcon' in last line and might be used  on later
// @ts-ignore
// export const CartIconComponent: React.FunctionComponent<ICartIconComponentProps> = msdyn365Commerce.createComponent<ICartIconComponent>(
//     'CartIcon',
//     { component: CartIcon, ...CartIconComponentActions }
// );

export default CartIcon;